module.exports = __webpack_public_path__ + "static/img/ers.9636473.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ers.jpg
// module id = aVdy
// module chunks = 0